import classNames from "classnames";
import {
  Dropdown,
  DropdownContent,
  DropdownItem,
  DropdownTrigger,
} from "@/components";
import type { ApiDeviceBranding } from "../../_types/device-brandings.types";
import { DotsVerticalIcon } from "@vetty/icons";
import styles from "./BrandingListItem.module.scss";

const formatTime = (ms: number) =>
  new Intl.DateTimeFormat(undefined, { dateStyle: "medium", timeStyle: "short" }).format(new Date(ms));

type BrandingListItemProps = {
  branding: ApiDeviceBranding;
  onRowClick: () => void;
  onEdit: () => void;
  onDuplicate: () => void;
  onRequestDelete: () => void;
  actionsDisabled: boolean;
};

export const BrandingListItem = ({
  branding,
  onRowClick,
  onEdit,
  onDuplicate,
  onRequestDelete,
  actionsDisabled,
}: BrandingListItemProps) => {
  return (
    <div className={styles["comp"]}>
      <button
        type="button"
        className={styles["comp__main"]}
        onClick={onRowClick}
        aria-label={`Open details for ${branding.name}`}
      >
        <span className={styles["comp__name"]}>{branding.name}</span>
        <span className={styles["comp__display"]}>{branding.displayName ?? "—"}</span>
        <span className={styles["comp__accent"]}>
          {branding.accentColor ? (
            <span
              className={styles["comp__swatch"]}
              style={{ background: branding.accentColor }}
              title={branding.accentColor}
            />
          ) : (
            "—"
          )}
        </span>
        <time className={styles["comp__updated"]} dateTime={new Date(branding.updatedAt).toISOString()}>
          {formatTime(branding.updatedAt)}
        </time>
      </button>

      <div className={styles["comp__actions"]}>
        <Dropdown>
          <DropdownTrigger className={styles["comp__dropdownTrigger"]}>
            <button
              type="button"
              className={styles["comp__menuTrigger"]}
              aria-label="Branding actions"
              aria-haspopup="menu"
              disabled={actionsDisabled}
            >
              <DotsVerticalIcon style={{ width: 20, height: 20 }} aria-hidden />
            </button>
          </DropdownTrigger>
          <DropdownContent width={180} lockBodyScroll={false}>
            <DropdownItem
              id={`${branding.id}-edit`}
              selectable={false}
              className={styles["comp__menuItem"]}
              disabled={actionsDisabled}
              onClick={() => onEdit()}
            >
              Edit
            </DropdownItem>
            <DropdownItem
              id={`${branding.id}-duplicate`}
              selectable={false}
              className={styles["comp__menuItem"]}
              disabled={actionsDisabled}
              onClick={() => onDuplicate()}
            >
              Duplicate
            </DropdownItem>
            <DropdownItem
              id={`${branding.id}-delete`}
              selectable={false}
              className={classNames(styles["comp__menuItem"], styles["comp__menuItem--danger"])}
              disabled={actionsDisabled}
              onClick={() => onRequestDelete()}
            >
              Delete
            </DropdownItem>
          </DropdownContent>
        </Dropdown>
      </div>
    </div>
  );
};
